<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:05:09
 * @FilePath: \zhucai_user\src\pages\member\child\bm.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">考证目标</div>
    <div class="my-content">
      <div class="my-search-box">
        <el-select
          v-model="getListData.ClassifyID"
          placeholder="证书类型"
          clearable
          @change="getList"
        >
          <el-option
            v-for="(it, i) in certificateTypeList"
            :key="i"
            :label="it.ClassifyName"
            :value="it.ClassifyID"
          />
        </el-select>
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.Title"
            placeholder="搜索证书分类名称"
          />
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
        <div class="right">
          <el-button @click="hanldEdit(0)" class="search-btn"
            >新增考证目标</el-button
          >
        </div>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="ClassifyName" label="证书类型">
        </el-table-column>
        <el-table-column prop="CertName" label="证书分类" align="center">
        </el-table-column>
        <el-table-column prop="CertLevel" label="证书级别" align="center">
        </el-table-column>

        <el-table-column
          prop="PlanTimeTxt"
          label="计划考试时间"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="SourceTxt"
          label="类型"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" width="400" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="hanldEdit(2, scope.row)">
              查看
            </el-button>
            <el-button
              v-if="scope.row.SourceID == 2"
              class="table-btn"
              @click="hanldEdit(1, scope.row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="scope.row.SourceID == 2"
              class="table-btn"
              @click="hanldDel(scope.row)"
            >
              删除
            </el-button>
            <el-button
              v-if="scope.row.SourceID == 1"
              class="table-btn"
              @click="hanldHidden(scope.row)"
            >
              暂不需要
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
    <certTargetDialog
      ref="dialog"
      :id="id"
      :type="type"
      @closePop="close"
    ></certTargetDialog>
  </div>
</template>

<script>
import {
  Classify_GetList,
  Enroll_UserSubEnroll,
  MyCertTargetDel,
  MyCertTargetHidden,
  GetMyCertTargetList,
} from "@/api/member";
import certTargetDialog from "./child/certTargetDialog";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination, certTargetDialog },
  name: "certTarget",
  data() {
    return {
      id: 0,
      type: 0, //0新增 1编辑 2查看
      showType: 0, //0:证书 1:查看
      SubjectID: 0,
      dialogShow: false,
      formList: [],
      certificateTypeList: [], //证书类型
      isLoading: false,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        ClassifyID: "",
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getClassifyList();
    this.getList();
  },
  methods: {
    getClassifyList() {
      Classify_GetList().then((res) => {
        this.certificateTypeList = res.data;
      });
    },

    hanldEdit(type, row) {
      this.type = 0;
      setTimeout(() => {
        if (row) {
          this.id = row.TargetID || 0;
        } else {
          this.id = 0;
        }
        this.type = type;
        this.$refs.dialog.open();
      }, 100);
    },
    hanldHidden(data) {
      MyCertTargetHidden({
        TargetID: data.TargetID,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getList();
        } else {
          
        }
      });
    },
    hanldDel(data) {
      this.$confirm("此操作将删除考证, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        customClass: "my-messagebox",
      }).then(() => {
        MyCertTargetDel({
          TargetID: data.TargetID,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.getList();
          } else {
            
          }
        });
      });
    },
    close() {
      this.id = 0;
      this.getList();
    },
    getList() {
      this.isLoading = true;
      const data = {
        ...this.getListData,
      };
      GetMyCertTargetList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-search-box {
  position: relative;
  .my-search {
    width: 251px;
  }
  .el-select,
  .el-date-editor {
    ::v-deep .el-input__inner {
      width: 201px;
      height: 47px;
      background: #f6f8fc;
      border-radius: 23px;
      border: 1px solid #e6e6e6;
    }
  }
  .right {
    position: absolute;
    right: 0;
    .search-btn {
      width: 141px;
    }
  }
}
.width510 {
  ::v-deep .el-dialog {
    width: 510px;
  }
}
.bmName {
  font-size: 20px;
  color: #333333;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.time {
  margin-top: 5px;
  font-size: 16px;
  color: #666666;
}
.StatusID {
  font-size: 16px;
  color: #1d79ff;
}
.my-form {
  .mt-form-item {
    margin-bottom: 20px;
    .label {
      font-size: 16px;
      color: #333333;
      margin-bottom: 10px;
    }
    .must {
      color: #ef3d3d;
    }
  }
  ::v-deep .el-input__inner {
    width: 470px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
}
.submit-btn {
  width: 144px;
  height: 46px;
  font-size: 16px;
  color: #ffffff;
  background: #1d79ff;
  border-radius: 6px;
}
</style>
